import React from 'react';
import { Button, ButtonProps } from '@material-ui/core';
import { MenuOutlined } from '@material-ui/icons';
import styled from 'styled-components';

const BaseMobileButton = ({ ...other }: ButtonProps) => (
    <Button {...other}>
        <MenuOutlined />
    </Button>
);

export const MobileButton = styled(BaseMobileButton)`
    color: ${({ theme }) => theme.palette.primary.main};

    svg {
        width: 40px;
        height: 40px;
    }
`;
